import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { TrafficModel } from '../../shared/models/traffic-related/TrafficModel';

@Injectable()
export class TrafficHistoryService {

    private actionUrl: string;
    private headers: Headers;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/Traffic/`;
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public GetAll = (searchParams: any): Observable<TrafficModel[]> => {
        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                params.set(key, val);
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    private DateToString(date: Date): string {
        return ((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/traffic/traffic-history/traffic-history.service.ts